module.exports = __webpack_public_path__ + "img/mianshi-1.ef96b62b.jpeg";